import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import CxyeerUzNjngdGCUGLHygasjkbBthiLaZ from "/vercel/path0/pkg/timvir/blocks/Arbitrary/samples/basic";
import {Arbitrary} from "..";
import {Exhibit} from "timvir/blocks";
function _createMdxContent(props) {
  const _components = {
    code: "code",
    h1: "h1",
    h2: "h2",
    p: "p",
    pre: "pre",
    ..._provideComponents(),
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h1, {
      children: "Arbitrary"
    }), "\n", _jsxs(_components.p, {
      children: ["The ", _jsx(_components.code, {
        children: "<Arbitrary>"
      }), " component manages a React context that contains a seed. This seed is displayed\nin an input field where users can copy it from."]
    }), "\n", _jsxs(_components.p, {
      children: ["The component renders its children in an ", _jsx(_components.code, {
        children: "<Exhibit>"
      }), ". The children can make use of the seed in the\nReact context to render themselves in a predictable way."]
    }), "\n", _jsx(CxyeerUzNjngdGCUGLHygasjkbBthiLaZ, {}), "\n", _jsx(_components.h2, {
      children: "Usage"
    }), "\n", _jsx(_components.p, {
      children: "Given a component-under-test:"
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-jsx",
        children: "import { useContext } from \"timvir/blocks/Arbitrary\"\n\nfunction Component() {\n  const { seed } = useContext();\n  return <div>{seed}</div>;\n}\n"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["We can take it and display it inside an ", _jsx(_components.code, {
        children: "<Arbitrary>"
      }), " in a timvir doc page:"]
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-jsx",
        children: "import { Arbitrary } from \"timvir/blocks\"\nimport { Component } from \"..\"\n\n<Arbitrary>\n  <Component />\n</Arbitrary>\n"
      })
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
